export const isLoggedIn = () => {
  const token = localStorage.getItem('accessToken');
  return !!token;
};

export const isAuthenticated = () => {
  const token = localStorage.getItem('accessToken');
  // const userId = localStorage.getItem('user_id');
  return !!token;
};

export const getAuthToken = () => {
  return localStorage.getItem('accessToken');
};

export const getUserId = () => {
  return localStorage.getItem('user_id');
};

// Helper function to format member count
export const formatMemberCount = (count) => {
  if (count >= 1000000) {
    return `${(count / 1000000).toFixed(1)}M`;
  } else if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}k`;
  }
  return count.toString();
};
